import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromBoardState from './board-state.reducer';
import cloneDeep from 'lodash/cloneDeep';
import { AddComponentToUserBoardItem, UserBoard } from 'src/app/services/models/user-board.model';

export const selectBoardState = createFeatureSelector<fromBoardState.BoardState>(
  fromBoardState.boardStateFeatureKey
);

export const selectBoardColors= createSelector(
  selectBoardState,
  state => state?.colors
)

export const selectDatasetList = createSelector(
  selectBoardState,
  state => cloneDeep(state?.datasets)
)

export const selectUserBoardList = createSelector(
  selectBoardState,
  state => {
    var clonedUserBoards = cloneDeep(state?.userBoards);
    clonedUserBoards.forEach((userBoard: UserBoard) => {
      userBoard.itemList.forEach((item: any) => {
        AddComponentToUserBoardItem(item);
      });
    });
    return clonedUserBoards;
  }
)

export const selectFilterList = createSelector(
  selectBoardState,
  state => state?.filters
)

export const selectFilterBarList = createSelector(
  selectBoardState,
  state => state?.filterBars
)

export const selectMetricList = createSelector(
  selectBoardState,
  state => state?.metrics
)
